import { createActionGroup, props } from '@ngrx/store';

export const redeemInviteActions = createActionGroup({
  source: 'Redeem Invite',
  events: {
    Opened: props<{
      token: string | undefined;
    }>(),
  },
});
